export default function onShowMore() {
	// tabindex management is handled by collapseBox.js via Alpine $watch.
	// This file is kept for any non-Alpine click-side-effects if needed.
}
